/*eslint-disable*/
import React, { useEffect, useState, useRef } from "react";
// nodejs library that concatenates classes
import { Helmet } from "react-helmet";
import axios from "axios";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { headApi, credentials } from "utils/headApi";
import { FiPhoneCall } from "react-icons/fi";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
// core components
// import Header from "components/Header/Header.js";
import HeaderAdminList from "components/Header/HeaderAdminList";
import Footer from "views/Main/MainFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// import HeaderLinks from "components/Header/HeaderLinks.js";

import Button from "components/CustomButtons/Button.js";
// sections for this page
import ProductImage from "views/Admin/ProductImage.js";
import ProductList from "views/Admin/ProductList.js";
import AboutCompany from "views/Admin/AboutCompany.js";
import RateAndReview from "views/Admin/RateAndReview.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";

import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import Slide from "@material-ui/core/Slide";

import CustomInput from "components/CustomInput/CustomInput.js";

import Card from "components/Card/Card.js";
// import Dialog from "@material-ui/core/Dialog";
// import DialogTitle from "@material-ui/core/DialogTitle";
// import DialogContent from "@material-ui/core/DialogContent";
import NavPills from "components/NavPills/NavPills.js";
import EmailIcon from "@material-ui/icons/Email";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";

import componentsStyle from "assets/jss/material-kit-pro-react/views/componentsStyle.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

const useStyles = makeStyles(componentsStyle);
const useStyleHead = makeStyles(headersStyle);
const useStyPop = makeStyles(javascriptStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export default function AdminList() {
  const [refundModal, setRefundModal] = React.useState(false);
  const [loginModal, setLoginModal] = React.useState(false);

  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [otpNumber, setOtpNumber] = React.useState("");
  const [otpNumberErr, setOtpNumberErr] = React.useState("");
  const [otpScreen, setOtpScreen] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [admin, setAdmin] = React.useState("");

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);

  const [emailConfirm, setEmailConfirm] = React.useState("");
  const [emailConfirmErr, setEmailConfirmErr] = React.useState("");

  const [otpMpin, setOtpMpin] = React.useState("");
  const [forgotPass, setForgotPass] = React.useState(false);
  const [otpConfirm, setOtpConfirm] = React.useState(false);
  const [updatePassword, setUpdatePassword] = React.useState(false);

  const [password, setPassword] = useState(["", "", "", "", "", ""]);
  const [passwordErr, setPasswordErr] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState(["", "", "", "", "", ""]);
  const [passwordConfirmErr, setPasswordConfirmErr] = useState("");
  const [updatePasswordConfirm, setUpdatePasswordConfirm] = useState(["", "", "", "", "", ""]);
  const [updatePasswordConfirmErr, setUpdatePasswordConfirmErr] = useState("");

  // ✅ Refs - separate for each section
  const inputs = useRef([]);          // Login / OTP input refs
  const inputsConfirm = useRef([]);   // Confirm Code input refs
  const inputsUpdate = useRef([]);    // Update mPIN input refs

  // Initialize refs only once
  useEffect(() => {
    inputs.current = Array(6)
      .fill()
      .map((_, i) => inputs.current[i] || React.createRef());
    inputsConfirm.current = Array(6)
      .fill()
      .map((_, i) => inputsConfirm.current[i] || React.createRef());
    inputsUpdate.current = Array(6)
      .fill()
      .map((_, i) => inputsUpdate.current[i] || React.createRef());
  }, []);

  const activeSession = sessionStorage.getItem("sessionData");
  const clientObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const search = useLocation().search;
  const a = new URLSearchParams(search).get("a");
  const p = new URLSearchParams(search).get("p");
  const category = new URLSearchParams(search).get("category");
  const state = new URLSearchParams(search).get("state");
  const catSize = new URLSearchParams(search).get("catSize");
  const country = new URLSearchParams(search).get("country");
  const d = new URLSearchParams(search).get("d");

  const location = useLocation();

  useEffect(() => {
    if (d === "o") {
      setLoginModal(true);
    }
  }, [location]);

  React.useEffect(() => {
    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (window.location.href.lastIndexOf("#") > 0) {
      document.getElementById(href).scrollIntoView();
    }
    window.addEventListener("scroll", updateView);
    updateView();
    return function cleanup() {
      window.removeEventListener("scroll", updateView);
    };
  });
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };
  const updateView = () => {
    var contentSections = document.getElementsByClassName("cd-section");
    var navigationItems = document
      .getElementById("cd-vertical-nav")
      .getElementsByTagName("a");

    for (let i = 0; i < contentSections.length; i++) {
      var activeSection =
        parseInt(navigationItems[i].getAttribute("data-number"), 10) - 1;
      if (
        contentSections[i].offsetTop -
        window.innerHeight / 2 +
        document.getElementById("main-panel").offsetTop <
        window.pageYOffset &&
        contentSections[i].offsetTop +
        contentSections[i].scrollHeight -
        window.innerHeight / 2 +
        document.getElementById("main-panel").offsetTop >
        window.pageYOffset
      ) {
        navigationItems[activeSection].classList.add("is-selected");
      } else {
        navigationItems[activeSection].classList.remove("is-selected");
      }
    }
  };
  const smoothScroll = (target) => {
    // console.log(target);

    var targetScroll = document.getElementById(target);
    scrollTo(document.documentElement, targetScroll.offsetTop, 900);
  };
  const scrollTo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start + document.getElementById("main-panel").offsetTop,
      currentTime = 0,
      increment = 20;

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  const classes = useStyles();
  const classeHead = useStyleHead();
  const classPop = useStyPop();
  const history = useHistory();

  async function getProdSEO() {
    const results = await fetch(
      headApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }
    );
    const res = await results.json();

    // console.log(res.map((f) => f.state));
    setStateList(res.map((f) => f.state))

    axios.get(headApi + `/admin/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      setCompanyList(res.data.AdminList.map((f) => f.company))
    });

    axios.get(headApi + `/category/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      const items = res.data.map((f) => f.title);

      const uniqueItems = items.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );

      setCategoryList(uniqueItems);
    });

    axios.get(headApi + `/parent/allList`, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }).then((res) => {
      const itemss = res.data.map((f) => f.title);

      const uniqueItemss = itemss.filter(
        (item, index, self) =>
          index === self.findIndex(i => i.toLowerCase() === item.toLowerCase())
      );
      setParentList(uniqueItemss);
    });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  async function getAdmin() {
    const api = headApi + `/admin/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setAdmin(getResult.AdminList);

  }

  useEffect(() => {
    getAdmin();
  }, []);

  // ✅ Password change handlers
  const handlePasswordChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...password];
      updated[index] = text;
      setPassword(updated);

      if (text && index < 5) {
        inputs.current[index + 1] && inputs.current[index + 1].focus();
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !password[index] && index > 0) {
      inputs.current[index - 1] && inputs.current[index - 1].focus();
    }
  };

  // ✅ Confirm Code handlers
  const handlePasswordChangeConfirm = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...passwordConfirm];
      updated[index] = text;
      setPasswordConfirm(updated);

      if (text && index < 5) {
        inputsConfirm.current[index + 1] && inputsConfirm.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirm = (e, index) => {
    if (e.key === "Backspace" && !passwordConfirm[index] && index > 0) {
      inputsConfirm.current[index - 1] && inputsConfirm.current[index - 1].focus();
    }
  };

  // ✅ Update Password handlers
  const handlePasswordChangeConfirmUpdate = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...updatePasswordConfirm];
      updated[index] = text;
      setUpdatePasswordConfirm(updated);

      if (text && index < 5) {
        inputsUpdate.current[index + 1] && inputsUpdate.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirmUpdate = (e, index) => {
    if (e.key === "Backspace" && !updatePasswordConfirm[index] && index > 0) {
      inputsUpdate.current[index - 1] && inputsUpdate.current[index - 1].focus();
    }
  };

  const handleMobileNumber = (mobile) => {
    setMobile(mobile);
    // setMobileErr("");
    fetch(headApi + `/register/find/byMobile/${mobile}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result);
          // setMobileErr(result.message);
          if (result.message === "Mobile No. Already Registered") {
            setMobileErr("");
          } else if (result.message === "Not Found") {
            setMobileErr("Your No. Not Registered");
          } else {
            setMobileErr(result.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
    fetch(headApi + `/register/find/byEmail/${value}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // setEmailErr(result.message);
          if (result.message === "Email ID Already Registered") {
            setEmailErr("");
          } else if (result.message === "Not Found") {
            setEmailErr("Your Email Not Registered");
          } else {
            setEmailErr(result.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleEmailConfirm = (e) => {
    const { value } = e.target;
    setEmailConfirm(value);
    if (value) {
      fetch(headApi + `/register/find/byEmail/${value}`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            // setEmailErr(result.message);
            if (result.message === "Email ID Already Registered") {
              setEmailConfirmErr("");
            } else if (result.message === "Not Found") {
              setEmailConfirmErr("Your Email Not Registered");
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  const handleOtp = (e) => {
    // console.log(e.target.value);
    setOtpNumber(e.target.value);
    setOtpNumberErr("");
  };

  const handleSendOtpWithMobile = async () => {
    // const getFindAdmin = admin.find(
    //   (f) => f.websitename === "inshabangles.com"
    // );
    const getFindAdmin = admin.find((f) => f.id == a);
    const api = headApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        headApi +
        `/otp/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("OTP")
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendPasswordWithMobile = async () => {
    // console.log("okkkk");
    const getFindAdmin = admin.find(
      (f) => f.websitename === "indianbangles.in"
    );
    const api = headApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        headApi +
        `/register/password/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("mPIN")
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendOtpWithEmail = async () => {
    // const getFindAdmin = admin.find(
    //   (f) => f.websitename === "inshabangles.com"
    // );
    const getFindAdmin = admin.find((f) => f.id == a);
    const api = headApi + `/register/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        to: email,
        subject: "API CREATION SUBJECT",
        websitename: "indianbangles.in",
        followId: getFindAdmin.id,
        adminId: getResult.aId,
      }),
    };
    fetch(
      headApi + `/otp/send/byEmail?e=noreply@indianbangles.in`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        setEmailErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginWithMobile = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (passwordString === "" || !passwordString || passwordString.length !== 6) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        headApi +
        `/register/recieved/byMobile?mobile=${mobile}&otp=${passwordString}`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const clientObj = response.registerSession;
            localStorage.setItem("clientObj", JSON.stringify(clientObj));
            sessionStorage.setItem("sessionData", JSON.stringify(clientObj));
            // history.push("/product-list");
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithMobilePassword = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (passwordString === "" || !passwordString || passwordString.length !== 6) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        headApi +
        `/register/recieved/byMobilePassword?mobile=${mobile}&password=${passwordString}`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const clientObj = response.registerSession;
            localStorage.setItem("clientObj", JSON.stringify(clientObj));
            sessionStorage.setItem("sessionData", JSON.stringify(clientObj));
            // history.push("/product-list");
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  const handleLoginWithEmail = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (passwordString === "" || !passwordString || passwordString.length !== 6) {
      errorCount++;
      setOtpNumberErr("Enter Otp Number");
    }
    if (errorCount === 0) {
      fetch(
        headApi + `/register/recieved/byEmail?email=${email}&otp=${passwordString}`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const clientObj = response.registerSession;
            localStorage.setItem("clientObj", JSON.stringify(clientObj));
            sessionStorage.setItem("sessionData", JSON.stringify(clientObj));
            // history.push("/product-list");
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // Open dialog every 3 seconds and close it after 2 seconds
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRefundModal(true); // Open dialog every 3 seconds

  //   }, 6000); // Set to open dialog every 3 seconds

  //   // Cleanup the interval when the component is unmounted or when the effect is re-run
  //   return () => clearInterval(interval);
  // }, []);

  const handleLogOut = () => {
    // console.log(clientObj);

    fetch(headApi + `/otp/logout/registerById/${clientObj && clientObj.id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        if (response.error === true) {
          localStorage.removeItem("sessionData");
          sessionStorage.removeItem("sessionData");
          // history.push("/");
          window.location.reload(false);
          setLoginModal(false)
        }

      });
  };

  const inputDigit = {
    width: "40px",
    height: "40px",
    fontSize: "20px",
    textAlign: "center",
    borderRadius: "8px",
    border: "1px solid #ccc",
  };

  const containerDigit = {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "20px",
    // marginLeft: "25px"
  };

  return (
    <div>
      <Helmet>
        <title>B2B List</title>
        <meta name="description" content="Best B2B Comapnay" />
        <meta
          name="keywords"
          content={`${categoryList},${parentList},${stateList},${companyList}`}
        />
        <meta name="keywords" content="Shaikh Imran" />
        {/*<meta name="keywords" content="Andhra Pradesh, Arunachal Pradesh, Assam, Bihar, Chhattisgarh, Goa, Gujarat, Haryana, Himachal Pradesh, Jharkhand, Karnataka, Kerala, Madhya Pradesh, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Odisha, Punjab, Rajasthan, Sikkim, Tamil Nadu, Telangana, Tripura, Uttar Pradesh, Uttarakhand, West Bengal" /> */}
      </Helmet>
      <HeaderAdminList
        absolute
        // fixed
        brand="Home"
        color="transparent"
        links={
          <div className={classeHead.collapse}>
            <List className={classeHead.list + " " + classeHead.mlAuto}>
              <ListItem className={classeHead.listItem}>
                <Button
                  className={classeHead.navLink}
                  onClick={(e) => e.preventDefault()}
                  color="transparent"
                >
                  Help
                </Button>
              </ListItem>
              <ListItem className={classeHead.listItem}>
                <Button
                  className={classeHead.navLink}
                  onClick={(e) => e.preventDefault()}
                  color="transparent"
                >
                  Message
                </Button>
              </ListItem>
              <ListItem className={classeHead.listItem}>
                {!activeSession ? (
                  <Button
                    className={classeHead.navLink}
                    onClick={() => {
                      setLoginModal(true);
                    }}
                    color="transparent"
                  >
                    Log In
                  </Button>
                ) : (
                  <Button
                    className={classeHead.navLink}
                    onClick={handleLogOut}
                    color="transparent"
                  >
                    Log Out
                  </Button>
                )}
              </ListItem>
            </List>
          </div>
        }
      />
      <Parallax
        image={require("assets/img/bg7.jpg").default}
        filter="rose"
        className={classes.parallax}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1>
                  B2B INDIAN BANGLES{" "}
                  <span className={classes.proBadge}>PRO</span>
                </h1>
                <h3 className={classes.title}>All Components</h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div
        className={classNames(classes.main, classes.mainRaised)}
        id="main-panel"
      >
        <ProductImage />
        <ProductList />
        <AboutCompany />
        <RateAndReview />
        <GridContainer>
          {!activeSession ? (
            <GridItem xs={12} sm={6} md={6} lg={6}>
              <Dialog
                classes={{
                  root: classPop.modalRoot,
                  paper: classPop.modal + " " + classPop.modalLogin,
                }}
                open={loginModal}
                TransitionComponent={Transition}
                keepMounted
                // onClose={() => setLoginModal(false)}
                aria-labelledby="login-modal-slide-title"
                aria-describedby="login-modal-slide-description"
              >
                <Card plain className={classPop.modalLoginCard}>
                  <DialogTitle
                    id="login-modal-slide-title"
                    disableTypography
                    className={classPop.modalHeader}
                  >
                    <CardHeader
                      plain
                      color="rose"
                      className={
                        classPop.textCenter + " " + classPop.cardLoginHeader
                      }
                    >
                      <Button
                        simple
                        className={classPop.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        onClick={() => {
                          setLoginModal(false);
                          history.push(
                            `/list?a=${a}&p=${p}&category=${category}&catSize=${catSize}&country=${country}&state=${state}`
                          );
                        }}
                      >
                        {" "}
                        <Close className={classPop.modalClose} />
                      </Button>
                      <h5 className={classPop.cardTitleWhite}>Log in</h5>
                    </CardHeader>
                  </DialogTitle>
                  <DialogContent
                    id="login-modal-slide-description"
                    className={classPop.modalBody}
                  >
                    {!otpScreen ? (
                      <form>
                        <p
                          className={
                            classPop.description + " " + classPop.textCenter
                          }
                        >
                          Welcome
                        </p>
                        <CardBody className={classPop.cardLoginBody}>
                          <GridContainer justify="center">
                            <NavPills
                              color="rose"
                              alignCenter
                              tabs={[
                                {
                                  tabButton: "Mobile",
                                  tabIcon: PhoneAndroidIcon,
                                  tabContent: (
                                    <>
                                      <GridContainer style={{ marginTop: -10 }}>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <PhoneInput
                                            inputStyle={{
                                              width: "100%",
                                              border: "none",
                                              borderBottom: "1px solid #040000 ",
                                              borderRadius: "0",
                                            }}
                                            country={"in"}
                                            name="mobile"
                                            value={mobile}
                                            onChange={(mobile) => {
                                              handleMobileNumber(mobile);
                                            }}
                                            required={true}
                                          />
                                          <span style={{ color: "red" }}>
                                            {mobileErr}
                                          </span>
                                        </GridItem>
                                      </GridContainer>
                                      <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                        <Button
                                          color="rose"
                                          onClick={handleSendOtpWithMobile}
                                          style={{ flex: 1, width: 50 }}
                                        >
                                          Continue via OTP
                                        </Button>

                                        <Button
                                          color="rose"
                                          onClick={handleSendPasswordWithMobile}
                                          style={{ flex: 1, width: 50 }}
                                        >
                                          Continue via mPIN
                                        </Button>
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  tabButton: "Email",
                                  tabIcon: EmailIcon,
                                  tabContent: (
                                    <>
                                      <GridContainer style={{ marginTop: -17 }}>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <CustomInput
                                            formControlProps={{
                                              fullWidth: true,
                                              className:
                                                classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                              onChange: (e) => handleEmail(e),
                                              id: "email",
                                              value: email,
                                              name: "email",
                                              placeholder: "Email...",
                                            }}
                                            required={true}
                                          />
                                          <span style={{ color: "red" }}>
                                            {emailErr}
                                          </span>
                                        </GridItem>
                                      </GridContainer>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center", // centers the button
                                          marginTop: "-15px", // reduce top space
                                        }}
                                      >
                                        <Button
                                          color="rose"
                                          style={{
                                            width: "100px", // fixed width for better centering
                                          }}
                                          onClick={handleSendOtpWithEmail}
                                        >
                                          Login
                                        </Button>
                                      </div>
                                    </>
                                  ),
                                },
                              ]}
                            />
                          </GridContainer>
                        </CardBody>
                        {/* <br /> */}
                        <div className={classes.textCenter}>
                          <h6>
                            Already have an account log in to Existing account
                          </h6>
                          <div style={{ marginTop: -10, paddingTop: 0 }}>
                            <Button
                              simple
                              color="rose"
                              href={`/sign-up?a=${a}&p=${p}&category=${category}&catSize=${catSize}&country=${country}&state=${state}`}
                            >
                              Create New Account
                            </Button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <form>
                        {!forgotPass && !otpConfirm && !updatePassword && (<>
                          <p
                            className={classPop.description + " " + classPop.textCenter}
                            style={{ marginLeft: "10px", marginRight: "10px" }}
                          >
                            6 digit {otpMpin} sent on your {mobile ? "Mobile" : "Email"}
                            <br />{mobile ? mobile : email}
                            {/* <br />{otp} {reSend} */}
                          </p>
                          <CardBody className={classPop.cardLoginBody}>
                            <div style={containerDigit}>
                              {password.map((digit, index) => (
                                <input
                                  key={index}
                                  ref={(el) => (inputs.current[index] = el)}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) => {
                                    handlePasswordChange(e.target.value, index);
                                    setPasswordErr("");
                                  }}
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                  style={inputDigit}
                                />
                              ))}

                            </div>
                            <p
                              className={classes.description + " " + classes.textCenter}
                              style={{ color: "red" }}
                            >
                              {otpNumberErr}
                            </p>
                          </CardBody>
                          <div style={{
                            textAlign: "center", // centers inline content
                            display: "flex",     // makes children flex items
                            justifyContent: "center", // horizontal center
                            alignItems: "center",     // vertical center if needed
                            gap: "10px"               // spacing between elements
                          }}>
                            <Button
                              simple
                              color="rose"
                              // size="lg"
                              onClick={
                                mobile ? otpMpin === "OTP" ? handleLoginWithMobile : handleLoginWithMobilePassword : handleLoginWithEmail
                              }
                            >
                              Log in
                            </Button>
                            <Button
                              simple
                              color="rose"
                            // size="lg"
                            // onClick={handleCall}
                            >
                              <FiPhoneCall /> Call Me
                            </Button>
                          </div>

                          <p className={classes.description} style={{
                            textAlign: "center", // centers inline content
                            display: "flex",     // makes children flex items
                            justifyContent: "center", // horizontal center
                            alignItems: "center",     // vertical center if needed
                            gap: "10px"               // spacing between elements
                          }}>
                            {otpMpin === "OTP" ? <>
                              Didn{"'"}t receive the OTP yet?{" "}
                              <span style={{ marginLeft: "10px" }}>
                                <a
                                  // href="#"
                                  onClick={
                                    mobile
                                      ? handleSendOtpWithMobile
                                      : handleSendOtpWithEmail
                                  }
                                >
                                  Resend OTP
                                </a>
                              </span> </> : <Button
                                color="transparent"
                                style={{ textTransform: "none", textDecoration: "underline", color: "red" }}
                                onClick={() => setForgotPass((prev) => !prev)}
                              >
                              Forgot Password?
                            </Button>}
                          </p>
                        </>)}

                        {/* EMAIL CONFIRM SECTION */}
                        {forgotPass && (
                          <CardBody style={{ textAlign: "center" }}>
                            <h5 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              Email Confirm
                            </h5>
                            <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              Enter Your Email
                            </h6>
                            <CustomInput
                              formControlProps={{
                                fullWidth: true,
                                className:
                                  classes.customFormControlClasses,
                              }}
                              inputProps={{
                                onChange: (e) => handleEmailConfirm(e),
                                id: "emailConfirm",
                                value: emailConfirm,
                                name: "emailConfirm",
                                placeholder: "Email...",
                              }}
                              required={true}
                            />
                            <span style={{ color: "red" }}>{emailConfirmErr}</span>
                            <br />

                            <Button
                              color="transparent"
                              style={{
                                textTransform: "none",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "red",
                              }}
                              onClick={async () => {

                                const getFindAdmin = admin.find(
                                  (f) => f.websitename === "indianbangles.in"
                                );
                                const api = headApi + `/register/byEmail/${email}`;
                                const result = await fetch(api, {
                                  method: "GET",
                                  headers: {
                                    Authorization: `Basic ${credentials}`,
                                  },
                                });
                                const getResult = await result.json();
                                fetch(
                                  headApi + `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                                  {
                                    method: "POST",
                                    headers: {
                                      "content-type": "application/json",
                                      accept: "application/json",
                                      Authorization: `Basic ${credentials}`,
                                    },
                                    body: JSON.stringify({
                                      to: email,
                                      subject: "API CREATION SUBJECT",
                                      websitename: "indianbangles.in",
                                      followId: getFindAdmin.id,
                                      adminId: getResult.aId,
                                    }),
                                  }

                                )
                                  .then((response) => response.json())
                                  .then((res) => {
                                    // console.log(res);

                                    if (res.message === "OTP Sent On Your Email ID Successfully") {
                                      // ✅ Close forgotPass when OTP is confirmed
                                      setOtpConfirm(true);
                                      setForgotPass(false);
                                    } else if (res.message === "Your Email And Mobile not Match ") {
                                      setEmailConfirmErr("Email & Mobile Not Match");
                                    }
                                    // "Sender Not Found to +919967457786"
                                  })
                                  .catch((err) => {
                                    console.log(err);
                                  });
                              }}
                            >
                              Confirm Email
                            </Button>
                          </CardBody>
                        )}

                        {/* OTP CONFIRM SECTION */}
                        {otpConfirm && (
                          <CardBody style={{ textAlign: "center" }}>
                            <h5 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              Enter Verification Code
                            </h5>
                            <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              For your Security we have sent the Code to your Email<br />
                              {emailConfirm}
                            </h6>
                            <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              Enter your 6-digit Code
                            </h6>

                            <div style={containerDigit}>
                              {passwordConfirm.map((digit, index) => (
                                <input
                                  key={index}
                                  ref={(el) => (inputsConfirm.current[index] = el)}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) => {
                                    handlePasswordChangeConfirm(e.target.value, index);
                                    setPasswordConfirmErr("");
                                  }}
                                  onKeyDown={(e) => handleKeyPressConfirm(e, index)}
                                  style={inputDigit}
                                />
                              ))}

                            </div>

                            <span style={{ color: "red" }}>{passwordConfirmErr}</span>
                            <br />

                            <Button
                              color="transparent"
                              style={{
                                textTransform: "none",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "red",
                              }}
                              onClick={() => {
                                const password = passwordConfirm.join("");

                                if (password.length !== 6) {
                                  setPasswordConfirmErr("mPIN must be exactly 6 digits.");
                                  return;
                                }

                                fetch(
                                  `${headApi}/register/recieved/byEmailAndMobile?email=${emailConfirm}&mobile=${mobile}&otp=${password}`,
                                  {
                                    method: "PUT",
                                    headers: { Authorization: `Basic ${credentials}` },
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((response) => {
                                    setPasswordConfirmErr(response.message);
                                    if (response.message === "Your Mobile And Email ID Match !!!") {
                                      setUpdatePassword(true);
                                      setOtpConfirm(false);
                                    }
                                  })
                                  .catch((err) => console.log(err));
                              }}
                            >
                              Confirm Code
                            </Button>
                            <br />

                            <Button
                              color="transparent"
                              style={{
                                textTransform: "none",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "red",
                              }}
                              onClick={async () => {

                                const getFindAdmin = admin.find(
                                  (f) => f.websitename === "indianbangles.in"
                                );
                                const api = headApi + `/register/byEmail/${emailConfirm}`;
                                const result = await fetch(api, {
                                  method: "GET",
                                  headers: {
                                    Authorization: `Basic ${credentials}`,
                                  },
                                });
                                const getResult = await result.json();
                                fetch(
                                  headApi + `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                                  {
                                    method: "POST",
                                    headers: {
                                      "content-type": "application/json",
                                      accept: "application/json",
                                      Authorization: `Basic ${credentials}`,
                                    },
                                    body: JSON.stringify({
                                      to: emailConfirm,
                                      subject: "API CREATION SUBJECT",
                                      websitename: "indianbangles.in",
                                      followId: getFindAdmin.id,
                                      adminId: getResult.aId,
                                    }),
                                  }

                                )
                                  .then((response) => response.json())
                                  .then((res) => {
                                    // console.log(res);

                                    if (res && res.message === "OTP Sent On Your Email ID Successfully") {
                                      setEmailConfirmErr("OTP Resend On Your Email ID");
                                    }
                                    // "Sender Not Found to +919967457786"
                                  })
                                  .catch((err) => {
                                    console.log(err);
                                  });
                              }}
                            >
                              Didn't receive the Code yet? <br /> Resend Code
                            </Button>
                          </CardBody>
                        )}

                        {/* UPDATE PASSWORD SECTION */}
                        {updatePassword && (
                          <CardBody style={{ textAlign: "center" }}>
                            <h5 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              Forgot mPIN
                            </h5>
                            <h6 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              Enter New 6-digit mPIN
                            </h6>

                            <div style={containerDigit}>
                              {updatePasswordConfirm.map((digit, index) => (
                                <input
                                  key={index}
                                  ref={(el) => (inputsUpdate.current[index] = el)}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) => {
                                    handlePasswordChangeConfirmUpdate(e.target.value, index);
                                    setUpdatePasswordConfirmErr("");
                                  }}
                                  onKeyDown={(e) => handleKeyPressConfirmUpdate(e, index)}
                                  style={inputDigit}
                                />
                              ))}

                            </div>

                            <span style={{ color: "red" }}>{updatePasswordConfirmErr}</span>
                            <br />

                            <Button
                              color="transparent"
                              style={{
                                textTransform: "none",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "red",
                              }}
                              onClick={async () => {
                                const password = updatePasswordConfirm.join("");

                                if (password.length !== 6) {
                                  setUpdatePasswordConfirmErr("mPIN must be exactly 6 digits.");
                                  return;
                                }

                                const requestOptions = {
                                  method: "PUT",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                    Authorization: `Basic ${credentials}`,
                                  },
                                  body: JSON.stringify({ password }),
                                };

                                const response = await fetch(
                                  `${headApi}/register/updatePassword/byMobile/${mobile}`,
                                  requestOptions
                                );
                                const data = await response.json();

                                if (data.message === "Data Updated Successfully !!!") {
                                  window.location.reload(false);
                                }
                              }}
                            >
                              Update mPIN
                            </Button>
                          </CardBody>
                        )}
                      </form>
                    )}
                  </DialogContent>
                </Card>
              </Dialog>
            </GridItem>
          ) : (
            ""
          )}
        </GridContainer>
      </div>

      <nav id="cd-vertical-nav">
        <ul>
          <li>
            <a
              // href="#buttons"
              href="#productImage"
              data-number="1"
              className=""
              onClick={(e) => {
                e.preventDefault();
                smoothScroll("productImage");
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Product Image</span>
            </a>
          </li>
          <li>
            <a
              href="#productList"
              data-number="2"
              className=""
              onClick={(e) => {
                e.preventDefault();
                smoothScroll("productList");
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Product List</span>
            </a>
          </li>
          <li>
            <a
              href="#aboutCompany"
              data-number="3"
              className=""
              onClick={(e) => {
                e.preventDefault();
                smoothScroll("aboutCompany");
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">About Company</span>
            </a>
          </li>
          <li>
            <a
              href="#review"
              data-number="5"
              className=""
              onClick={(e) => {
                e.preventDefault();
                smoothScroll("review");
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Review</span>
            </a>
          </li>
          <li>
            <a
              href="#contactAreas"
              data-number="6"
              className=""
              onClick={(e) => {
                e.preventDefault();
                smoothScroll("contactAreas");
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Contact</span>
            </a>
          </li>
        </ul>
      </nav>
      <Footer />
    </div>
  );
}
